import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Label } from "./Reveal";
import { Logo } from "./Logo";
import { EMAIL, BRAND, mailto } from "./content";
import { Link } from "react-router-dom";
import { FIELDS } from "@/content/fields";

export const Contact = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end end"] });
  const x = useTransform(scrollYProgress, [0, 1], ["-12%", "0%"]);
  return (
    <section ref={ref} className="relative overflow-hidden pt-28 sm:pt-40" data-testid="contact-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <Label>Ready when you are</Label>
          <h2 className="font-serif-d mt-6 text-6xl leading-[0.9] text-white sm:text-8xl lg:text-[9rem]">
            Send us your<br /><span className="italic text-[var(--teal)]">resume.</span>
          </h2>
          <p className="mt-8 max-w-xl text-base leading-relaxed text-slate-300 sm:text-lg">
            Attach your current resume, tell us the job type you're targeting, and say which tier you'd like. We'll reply with next steps.
          </p>
          <a href={mailto("Resume bullet rewrite")} data-testid="contact-email-link"
            className="mail-link group mt-10 inline-flex items-center gap-3 border-b-2 border-[var(--teal)] pb-2 text-2xl text-white transition-colors duration-300 hover:text-[var(--teal)] sm:text-4xl">
            {EMAIL} <ArrowUpRight className="h-7 w-7 shrink-0 transition-transform duration-300 group-hover:rotate-45" />
          </a>
        </Reveal>
      </div>
      <motion.p style={{ x }} aria-hidden="true"
        className="font-serif-d text-outline mt-24 select-none whitespace-nowrap text-[26vw] italic leading-[0.8]">
        {BRAND}
      </motion.p>
      <footer className="border-t border-white/10" data-testid="site-footer">
        <div className="mx-auto flex max-w-7xl flex-col gap-5 px-5 py-8 sm:px-8 lg:flex-row lg:items-center lg:justify-between">
          <Logo />
          <nav className="flex flex-wrap gap-x-5 gap-y-2 text-sm text-slate-300" aria-label="Footer">
            <Link to="/bullet-checker" className="hover:text-[var(--teal)]" data-testid="footer-checker-link">Free bullet checker</Link>
            <Link to="/blog" className="hover:text-[var(--teal)]" data-testid="footer-blog-link">Resume tips</Link>
            {FIELDS.map((f) => (
              <Link key={f.slug} to={`/resume-help/${f.slug}`} className="hover:text-[var(--teal)]">For {f.name.toLowerCase()}</Link>
            ))}
          </nav>
          <p className="text-sm text-slate-400">© 2026 {BRAND}. Resume bullets that prove it.</p>
        </div>
      </footer>
    </section>
  );
};
